var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "subnets"
    }
  }, [!_vm.subnetsLoaded ? [_c('Loader', {
    attrs: {
      "content-id": '',
      "message": 'Fetching Subnets'
    }
  })] : [_c('Metadata', {
    attrs: {
      "total-subnets": _vm.totalSubnets,
      "total-validators": _vm.totalValidators,
      "total-blockchains": _vm.totalBlockchains,
      "total-stake": _vm.totalStake
    }
  }), this.$vuetify.breakpoint.mdAndUp ? _c('div', {
    staticClass: "card"
  }, [_c('Tabs', {
    attrs: {
      "subnets": _vm.subnets
    }
  })], 1) : _vm._e(), this.$vuetify.breakpoint.smAndDown ? _c('div', {
    staticClass: "card selection"
  }, [_c('v-select', {
    attrs: {
      "items": _vm.subnetsByName,
      "label": "Select Subnet",
      "outlined": ""
    },
    model: {
      value: _vm.selection,
      callback: function callback($$v) {
        _vm.selection = $$v;
      },
      expression: "selection"
    }
  }), _c('Content', {
    attrs: {
      "subnet-i-d": _vm.selection,
      "subnet": _vm.subnets[_vm.selection]
    }
  })], 1) : _vm._e()]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }